import { useState, useEffect } from "react";
import { client } from "../../../services/client";

/**
 * Fetches all learning modules from Sanity.io.
 */
export const useModuleData = () => {
  const [modules, setModules] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const query = `*[_type == "module"]{
      _id,
      title,
      slug,
      description,
      "coverImage": coverImage.asset->url,
      order,
      "stepCount": count(steps)
    }`;

    client
      .fetch(query)
      .then((data) => {
        setModules(data);
        setIsLoading(false);
      })
      .catch(console.error);
  }, []);

  return { modules, isLoading };
};
